export default __webpack_public_path__ + "static/media/ic_search.a6adb9fe.svg";